const accordionEls = document.querySelectorAll(".accordion");

accordionEls?.forEach((accordionEl) => {
  const items = accordionEl.querySelectorAll(".accordion__item");
  items?.forEach((item) => {
    const button = item.querySelector(".accordion__button");

    const handleAccordionButtonClick = () => {
      items?.forEach((i) => {
        if (i === item) {
          i.classList.toggle("accordion--visible");
        } else {
          i.classList.remove("accordion--visible");
        }

        if (i.classList.contains("accordion--visible")) {
          i.setAttribute("aria-expanded", true);
        } else {
          i.setAttribute("aria-expanded", false);
        }
      });
    };

    button?.addEventListener("click", handleAccordionButtonClick);
  });
});
